import { getServiceVersion } from '@estee/elc-universal-utils';
import { ELCLogger, TriggerType } from '@estee/elc-logging';

export const JS_REPO = 'js-repo';
export const DRUPAL = 'drupal';
export const UNKNOWN = 'unknown/external';

enum REPO {
    INTEGRATION = '/integration.js-repo/',
    QA = '/qa.js-repo/',
    PROD = '/js-repo/'
}

interface IErrorPayload {
    error: Error;
    serviceName?: string;
    serviceVersion?: string;
    context: {
        url: string;
        line: number;
        column: number;
        siteUrl: string;
    };
}

export const getServiceName = (pathname: string) => {
    return pathname.includes(JS_REPO)
        ? pathname.replace(REPO.INTEGRATION, '').replace(REPO.QA, '').replace(REPO.PROD, '')
        : DRUPAL;
};

export const onScriptError = (siteUrl: string, logger: ELCLogger) => (
    message: string,
    url: string,
    line: number,
    column: number,
    error: Error
) => {
    const payload: IErrorPayload = {
        context: {
            siteUrl,
            url,
            line,
            column
        },
        error,
        serviceName: '',
        serviceVersion: ''
    };

    try {
        const parsedURL = new URL(url);
        const split = parsedURL.pathname.split('@');
        const serviceName = getServiceName(split[0]);
        payload.serviceName = serviceName;
        payload.serviceVersion = getServiceVersion(serviceName, split.length > 1 ? split[1] : '');
    } catch (err) {
        payload.serviceName = UNKNOWN;
    }

    logger.error({
        triggerType: TriggerType.runtimeError,
        payload,
        message
    });

    return false;
};
